// extracted by mini-css-extract-plugin
export default {"container":"GridContainer_container__rHCZ2"};